import { QIcon_chevron_bold_left } from '@repo/icons/index'
import { useState } from 'react'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import LinkLocale from '../../../modules/i18n/LinkLocale'
import { n_buy, n_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import AvatarImg from '../../common/AvatarImg'
import { AccountMenuList } from '../../container/PortalContainer'
const AchievementsTopBar = () => {
  const [showMenu, setShowMenu] = useState(false)

  const router = useAppRouter()
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()

  const isMobile = useIsMobile(undefined, 1040)

  const handleShowMenu = (e) => {
    e.stopPropagation()
    setShowMenu(!showMenu)
  }

  return (
    <div className="z-120 border-b-1 fixed top-0 flex h-[60px] w-full flex-col items-center border-gray-200 bg-white px-[16px] sm:px-[32px] lg:w-[calc(100%_-_80px)] xl:px-[0px]">
      <div className="relative mx-auto flex h-full w-full max-w-[1040px] items-center justify-between text-[14px]">
        <div className="flex cursor-pointer items-center whitespace-nowrap" onClick={() => router.back()}>
          <span>
            <QIcon_chevron_bold_left width={16} height={16} />
          </span>
          <span className="Body2-14Bd ml-[2px] text-gray-700">{t(n_common.btn_back_list)}</span>
        </div>
        <div className="flex h-full w-full flex-row items-center justify-end gap-x-[20px] text-[14px]">
          {!isMobile && (
            <>
              <LinkLocale href={urls.student.newPortal.pricing.index}>
                <div className="flex items-center">
                  <span className="mx-[6px]">{t(n_buy.title)}</span>
                </div>
              </LinkLocale>
              <div className="h-[20px] w-[1px] bg-gray-200" />
            </>
          )}
          <div className="relative flex cursor-pointer items-center" onClick={handleShowMenu}>
            <AvatarImg size={33} src={currentUser?.image_url} className="border-[1.5px] border-purple-300" />
          </div>
        </div>
        <AccountMenuList showMenu={showMenu} setShowMenu={setShowMenu} />
      </div>
    </div>
  )
}

export default AchievementsTopBar
